import { render, staticRenderFns } from "./CriteriaSurveyEmailSender.vue?vue&type=template&id=6c3d9ac0&scoped=true"
import script from "./CriteriaSurveyEmailSender.vue?vue&type=script&lang=ts"
export * from "./CriteriaSurveyEmailSender.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3d9ac0",
  null
  
)

export default component.exports